import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useParticipantIds, useActiveParticipant, useDaily } from '@daily-co/daily-react';
import { pageAtom, myNftAtom, myNftBackAtom, isAuthAtom } from '../../State';
import { useRecoilState, useSetRecoilState } from 'recoil';
import './NFT.css';
import 'react-loading-skeleton/dist/skeleton.css';
import NFTItem from './NFTItem';
import DataModel from '../Util/DataModel';
import { isElectron } from 'react-device-detect';
import { ReactComponent as HatenaSVG } from '../Images/buttons/hatenaButton.svg';
import { useConnect, useDisconnect, useAccount, useNetwork } from 'wagmi';
import { useTranslation } from 'react-i18next';
import ElectronMetaMaskLogin from '../ElectronMetaMask/ElectronMetaMaskLogin';
import { getImagePath } from '../Util/utils';

export default function NFTMy({ isFaceScreen = false }) {
  const callObject = useDaily();
  const { t } = useTranslation();

  //その他
  const [nftOwnArrayState, setNftOwnArrayState] = useState([]);
  const [loadingState, setLoadingState] = useState(false);
  const [noNFTExixt, setNoNFTExist] = useState(false);
  const [hatenaState, setHatenaState] = useState(false);
  const [showMetamaskLogin, setShowMetamaskLogin] = useState(false);
  const [electronHasAddress, setElectronHasAddress] = useState(false);

  //wagmi
  const { address, isConnected } = useAccount();
  //const address = '0xD24db0BFb387b0ED05F757e5F3b9cA1C59a82605';
  const { connect, connectors } = useConnect();
  const { disconnect } = useDisconnect();
  // const { chains } = useNetwork();

  //初回ロード時
  useEffect(() => {
    if (isElectron) {
      //自分の保有するNFT取得
      getWalletAddress();
    } else {
      //ウォレット接続中の場合
      if (isConnected) {
        getNFTListFromAddress();
      }
    }
  }, []);

  //接続状況の監視
  useEffect(() => {
    if (isConnected && address != null) {
      getNFTListFromAddress();
    }
  }, [isConnected, address]);

  //保有するNFTのリスト取得(エレクトロン用)
  async function getWalletAddress() {
    if (isElectron == false) return;
    //ローディング中
    setLoadingState(true);

    //NFTデータ取得
    const walletAddress = await DataModel.getUserData('walletaddress');

    //alert(walletAddress);

    if (walletAddress == null) {
      setLoadingState(false);
    } else {
      //アドレスがあってconnectしているフラグ
      setElectronHasAddress(true);

      //アドレスからNFTリストを取得
      getNFTListFromAddress(walletAddress);
    }
  }

  //ブラウザ用
  async function getNFTListFromAddress(walletAddress) {
    let checkAddress;
    if (walletAddress == null) {
      if (address == '' || address == null) return;
      checkAddress = address;
    } else {
      checkAddress = walletAddress;
    }

    //ローディング中
    setLoadingState(true);

    //NFTリストを取得
    const nftList = await DataModel.getAllNFTList(checkAddress);

    setOwnNFT(nftList);
  }

  //NFTリストのセット
  function setOwnNFT(nftList) {
    //ウォレットアドレスがない OR 各種エラー
    if (nftList == null) {
      setNoNFTExist(true);
      setNftOwnArrayState([]);
    }
    //ウォレットアドレスはあるが対応しているNFTが一つのない
    else if (nftList.length == 0) {
      setNoNFTExist(true);
      setNftOwnArrayState([]);
    }
    //対応しているNFTが一つ以上ある
    else {
      setNftOwnArrayState(nftList);
      setNoNFTExist(false);
    }

    //ローディング終了
    setLoadingState(false);
  }

  //メタマスクと接続
  // const connectToMetamask = async () => {
  //   //ダウンロードを施す
  //   if (isElectron == false) {
  //     //setShowDownloadApp(true);
  //     getNFTListFromAddress();
  //   }
  //   //メタマスクログインを表示
  //   else {
  //     setShowMetamaskLogin(true);
  //   }
  // };

  // //メタマスクの接続解除
  const tapDisconnect = async () => {
    var result = window.confirm(t('nft.Are you sure disconnect wallet?'));
    if (result) {
      setNoNFTExist(false);
      setNftOwnArrayState([]);

      if (isElectron) {
        setElectronHasAddress(false);
        //データベースからwalletaddressを削除
        const result = await DataModel.disconnectMetaMask();
        if (result != null) {
          // setNoNFTExist(false);
          // setNftOwnArrayState([]);
        }
      }

      disconnect();
    }
  };

  const hatenaOver = async () => {
    setHatenaState(true);
  };

  const hatenaOut = async () => {
    setHatenaState(false);
  };

  //MyNFTリストの表示

  return (
    <>
      {showMetamaskLogin && (
        <ElectronMetaMaskLogin
          setShowMetamaskLogin={setShowMetamaskLogin}
          getWalletAddress={getWalletAddress}
        />
      )}
      <div id="nftPartnerTitleWrap">
        {hatenaState && (
          <div id="nftPartnerTitleHatenaDetail">
            {t('nft.Connect Wallet...')} <br />
            {t('nft.Ethereum Supported...')}
            <br />
          </div>
        )}
        <div id="nftPartnerTitle">{t('nft.My NFT Avatars')}</div>
        <div id="nftPartnerTitleHatena" onMouseEnter={hatenaOver} onMouseLeave={hatenaOut}>
          <HatenaSVG />
        </div>
      </div>
      {loadingState ? (
        <div className="nft-main-loader">
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path-gray"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#70c542"
                strokeWidth="2"
              />
            </svg>
          </div>
          <div id="loadingnow">{t('nft.Loading...')}</div>
        </div>
      ) : (
        <>
          {/* ウォレット接続がまだの場合 */}
          {isConnected == false && electronHasAddress == false ? (
            <>
              <div id="metamaskBox">
                <div id="metamaskBoxTitle">{t('nft.Check the...')}</div>
                <button
                  onClick={() => {
                    if (isElectron == false) {
                      connect({ connector: connectors[2] });
                    } else {
                      setShowMetamaskLogin(true);
                    }
                  }}
                  className="loginButton">
                  <img src={getImagePath() + '/header/metaMask.svg'} />
                  <span> MetaMask</span>
                </button>

                <button
                  onClick={() => {
                    connect({ connector: connectors[0] });
                  }}
                  className="loginButton">
                  <img src={getImagePath() + '/icons/coinbase.png'} className="coinbase" />
                  <span> Coinbase Wallet</span>
                </button>

                <button
                  onClick={() => {
                    connect({ connector: connectors[1] });
                  }}
                  className="loginButton">
                  <img src={getImagePath() + '/icons/walletconnect.png'} />
                  <span> WalletConnect</span>
                </button>
              </div>
            </>
          ) : (
            <>
              {noNFTExixt ? (
                <>
                  {/* 対応しているNFTが存在しない */}
                  <div id="nftNoExist">{t('nft.No NFT has FACELESS avatar')}</div>
                  <div className="disconnectMetamask" onClick={tapDisconnect}>
                    {t('nft.disconnect')}
                  </div>
                </>
              ) : (
                <>
                  {/*自分が保有するNFT一覧 */}
                  <div id="nftPartnerList">
                    {/* <div className="myOwnNftList"> */}
                    {nftOwnArrayState.map((data) => {
                      return (
                        <NFTItem
                          key={data.nftID}
                          imageURL={data.imageURL}
                          thumbURL={data.nftID}
                          type={'pro'}
                          nftID={data.nftID}
                          showType="partnerList"
                          limit={data.whoCanUse}
                          nftName={data.name}
                          allow="ok"
                        />
                      );
                    })}
                  </div>
                  <div className="disconnectMetamask" onClick={tapDisconnect}>
                    {t('nft.disconnect')}
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
